
// import { BACKEND } from './counsellingConstants';
// import { apiEndPoints } from './apiConstants';

// // CREATE ROOM
// export async function createRoom(schoolName, studentName) {
//   const r = await fetch(`${BACKEND}${apiEndPoints.createCounsellingRoom}`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ schoolName, studentName }),
//   });
//   if (!r.ok) throw new Error('Failed to create room');
//   return r.json();
// }

// // GET VIDEO TOKEN
// export async function getVideoToken(roomName, participantName) {
//   const r = await fetch(`${BACKEND}${apiEndPoints.getCounsellingVideoToken}`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ roomName, participantName }),
//   });
//   const data = await r.json();
//   if (!r.ok) throw new Error(data.error || 'Token failed');
//   return data;
// }

// // VALIDATE ROOM  (FIX: endpoint now exists in apiConstants + backend router)
// export async function validateRoom(meetingId) {
//   const r = await fetch(
//     `${BACKEND}${apiEndPoints.validateCounsellingRoom}/${meetingId}`
//   );
//   if (!r.ok) return null;
//   return r.json();
// }

// // SAVE SCHOOL  (FIX: endpoint now exists in apiConstants + backend router)
// export async function saveSchool(counsellorId, schoolName, meetingId) {
//   const r = await fetch(`${BACKEND}${apiEndPoints.saveCounsellingSchool}`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ counsellorId, schoolName, meetingId }),
//   });
//   return r.json();
// }

// // GET SAVED SCHOOLS  (FIX: endpoint now exists in apiConstants + backend router)
// export async function getSavedSchools(counsellorId) {
//   const r = await fetch(
//     `${BACKEND}${apiEndPoints.getCounsellingSavedSchools}/${counsellorId}`
//   );
//   return r.json();
// }

// // DELETE SAVED SCHOOL  (FIX: endpoint now exists in apiConstants + backend router)
// export async function deleteSavedSchool(counsellorId, meetingId) {
//   const r = await fetch(`${BACKEND}${apiEndPoints.saveCounsellingSchool}`, {
//     method: 'DELETE',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ counsellorId, meetingId }),
//   });
//   return r.json();
// }

// // END ROOM  (FIX: endpoint now exists in apiConstants + backend router)
// export async function endRoom(meetingId) {
//   await fetch(`${BACKEND}${apiEndPoints.endCounsellingRoom}/${meetingId}`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ meetingId }),
//   });
// }


import { BACKEND } from './counsellingConstants'
import { apiEndPoints, apiHeaders } from './apiConstants'
import myPeeguAxios from './myPeeguAxios'
import { getVcSchoolSession } from './virtualCounsellingAuth'
import { getFetchErrorMessage } from './livekitErrorMessages'
import { getParticipantJoinErrorMessage } from './participantRoles'

export async function checkLiveKitHealth() {
  try {
    const r = await fetch(`${BACKEND}${apiEndPoints.livekitHealth}`)
    const data = await r.json()
    if (!r.ok || !data?.success) {
      return {
        ok: false,
        error: data?.error || 'LiveKit is not configured correctly on the server.',
        code: data?.code || null,
      }
    }
    return { ok: true, projectUrl: data.projectUrl }
  } catch (e) {
    return { ok: false, error: getFetchErrorMessage(e, 'Could not reach backend LiveKit health check.') }
  }
}

// GET VIDEO TOKEN
export async function getVideoToken(roomName, participantName, extra = {}) {
  const r = await fetch(`${BACKEND}${apiEndPoints.getCounsellingVideoToken}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ roomName, participantName, ...extra }),
  })
  const data = await r.json()
  if (!r.ok || data?.success === false) {
    const err = new Error(data?.error || data?.detail || 'Video token request failed')
    if (data?.code) err.code = data.code
    if (data?.role) err.role = data.role
    err.httpStatus = r.status
    err.userMessage = getParticipantJoinErrorMessage(err)
    throw err
  }
  if (!data?.token) throw new Error('Video token missing from server response.')
  return data
}

/** Super Admin Ghost Observer — authenticated; receive-only + hidden. */
export async function getObserverVideoToken(roomName) {
  try {
    const { data } = await myPeeguAxios.post(
      apiEndPoints.getCounsellingObserverToken,
      { roomName, meetingId: roomName },
      {
        headers: {
          [apiHeaders.preventDefaultLoader]: true,
          [apiHeaders.preventDefaultToast]: true,
        },
      },
    )
    if (!data?.success || !data?.token) {
      const err = new Error(data?.error || 'Observer token request failed')
      err.code = data?.code
      err.httpStatus = 403
      err.userMessage = data?.error || 'Could not join as Ghost Observer.'
      throw err
    }
    return data
  } catch (e) {
    if (e?.userMessage || e?.code) throw e
    const data = e?.response?.data
    const err = new Error(data?.error || e?.message || 'Observer token request failed')
    err.code = data?.code
    err.httpStatus = e?.response?.status || 403
    err.userMessage = data?.error || 'Could not join as Ghost Observer.'
    throw err
  }
}

/** Audit-only leave for Ghost Observer — does not end the counselling session. */
export async function registerObserverLeave(meetingId, identity) {
  try {
    await myPeeguAxios.post(
      `${apiEndPoints.counsellingObserverLeave}/${meetingId}/observer-leave`,
      { identity },
      {
        headers: {
          [apiHeaders.preventDefaultLoader]: true,
          [apiHeaders.preventDefaultToast]: true,
        },
      },
    )
  } catch {
    // best-effort audit
  }
}

// VALIDATE ROOM — never throws, always returns { valid: bool, error? }
export async function validateRoom(meetingId) {
  try {
    const r = await fetch(
      `${BACKEND}${apiEndPoints.validateCounsellingRoom}/${meetingId}`
    )
    const data = await r.json()
    if (!r.ok) return { valid: false, error: data.error || 'Invalid Room ID.' }
    return { valid: true, ...data }
  } catch {
    return { valid: false, error: 'Could not reach server. Check your connection.' }
  }
}

// END ROOM
export async function endRoom(meetingId) {
  try {
    await fetch(`${BACKEND}${apiEndPoints.endCounsellingRoom}/${meetingId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ meetingId }),
    })
  } catch {}
}

function buildMeetingQuery(params = {}) {
  const qs = new URLSearchParams()
  if (params.search) qs.set('search', params.search)
  if (params.status && params.status !== 'all') qs.set('status', params.status)
  if (params.sessionType && params.sessionType !== 'all') qs.set('sessionType', params.sessionType)
  if (params.page) qs.set('page', String(params.page))
  if (params.limit) qs.set('limit', String(params.limit))
  if (params.schoolIds?.length) qs.set('schoolIds', params.schoolIds.join(','))
  if (params.counsellorId) qs.set('counsellorId', params.counsellorId)
  return qs.toString()
}

export async function fetchScheduledMeetings(params = {}) {
  const query = buildMeetingQuery(params)
  const url = `${BACKEND}${apiEndPoints.scheduledCounsellingSessions}${query ? `?${query}` : ''}`
  try {
    const r = await fetch(url)
    const data = await r.json()
    if (!data?.success) throw new Error(data?.error || 'Failed to load meetings')
    return {
      sessions: data.sessions || [],
      pagination: data.pagination || { page: 1, limit: 10, total: 0, totalPages: 0 },
    }
  } catch (e) {
    throw new Error(getFetchErrorMessage(e, 'Failed to load meetings'))
  }
}

export async function fetchSchoolMeetings(schoolName, params = {}) {
  const qs = buildMeetingQuery({ ...params, schoolName: undefined })
  const base = `${BACKEND}${apiEndPoints.schoolCounsellingSessions}?schoolName=${encodeURIComponent(schoolName)}`
  const r = await fetch(qs ? `${base}&${qs}` : base)
  const data = await r.json()
  if (!data?.success) throw new Error(data?.error || 'Failed to load meetings')
  return {
    sessions: data.sessions || [],
    pagination: data.pagination || { page: 1, limit: 10, total: 0, totalPages: 0 },
  }
}

export async function scheduleCounsellingMeeting(payload) {
  const r = await fetch(`${BACKEND}${apiEndPoints.scheduleCounsellingSession}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  const data = await r.json()
  if (!r.ok || !data?.success) throw new Error(data?.error || 'Failed to schedule meeting')
  return data
}

export async function fetchMeetingById(meetingId) {
  const r = await fetch(`${BACKEND}${apiEndPoints.counsellingMeeting}/${meetingId}`)
  const data = await r.json()
  if (!r.ok || !data?.success) {
    const err = new Error(data?.error || 'Meeting not found')
    err.httpStatus = r.status
    throw err
  }
  return data.session
}

export async function fetchMeetingParticipants(meetingId) {
  const r = await fetch(`${BACKEND}${apiEndPoints.counsellingMeeting}/${meetingId}/participants`)
  const data = await r.json()
  if (!r.ok || !data?.success) throw new Error(data?.error || 'Could not load participants')
  return data.participants || []
}

export async function registerParticipantLeave(meetingId, payload = {}) {
  try {
    await fetch(`${BACKEND}${apiEndPoints.counsellingMeeting}/${meetingId}/participant-leave`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
  } catch {
    // best-effort cleanup
  }
}

export async function fetchStudentLastSession(studentId, excludeSessionId = '') {
  const qs = excludeSessionId ? `?excludeSessionId=${encodeURIComponent(excludeSessionId)}` : ''
  const r = await fetch(
    `${BACKEND}${apiEndPoints.studentLastCounsellingSession}/${studentId}/last${qs}`,
  )
  const data = await r.json()
  if (!r.ok || !data?.success) throw new Error(data?.error || 'Failed to load last session')
  return data.session
}

export async function patchCounsellingSession(sessionId, payload) {
  const r = await fetch(`${BACKEND}/counselor/v1/counselling/session/${sessionId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  const data = await r.json()
  if (!r.ok || !data?.success) throw new Error(data?.error || 'Failed to update session')
  return data
}

export async function endScheduledMeeting(meetingId) {
  const { data } = await myPeeguAxios.post(
    `${apiEndPoints.counsellingMeeting}/${meetingId}/end`,
  )
  if (!data?.success) throw new Error(data?.error || 'Failed to end meeting')
  return data
}

// ── School portal credentials (counsellor-managed) ──

export async function createSchoolPortalAccount(payload) {
  const { data } = await myPeeguAxios.post(apiEndPoints.createSchoolPortalAccount, payload)
  if (!data?.success) throw new Error(data?.error || 'Failed to create credentials')
  return data
}

export async function listSchoolPortalAccounts() {
  const { data } = await myPeeguAxios.get(apiEndPoints.listSchoolPortalAccounts)
  if (!data?.success) throw new Error(data?.error || 'Failed to load accounts')
  return data.accounts || []
}

export async function resetSchoolPortalPassword(accountId, password) {
  const { data } = await myPeeguAxios.put(
    `${apiEndPoints.resetSchoolPortalPassword}/${accountId}/password`,
    { password },
  )
  if (!data?.success) throw new Error(data?.error || 'Failed to reset password')
  return data
}

export async function deleteSchoolPortalAccount(accountId) {
  try {
    const { data } = await myPeeguAxios.post(
      `${apiEndPoints.deleteSchoolPortalAccount}/${accountId}/delete`,
    )
    if (!data?.success) throw new Error(data?.error || 'Failed to delete account')
    return data
  } catch (err) {
    const msg = err?.response?.data?.error || err.message || 'Failed to delete account'
    throw new Error(msg)
  }
}

export async function schoolPortalLogin(loginId, password) {
  const r = await fetch(`${BACKEND}${apiEndPoints.schoolPortalLogin}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ loginId, password }),
  })
  const data = await r.json()
  if (!r.ok || !data?.success) throw new Error(data?.error || 'Login failed')
  return data
}

export async function schoolPortalLogout() {
  const session = getVcSchoolSession()
  if (!session?.token) return
  try {
    await fetch(`${BACKEND}${apiEndPoints.schoolPortalLogout}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'vc-school-token': session.token },
    })
  } catch {}
}

export async function validateSchoolPortalSession() {
  const session = getVcSchoolSession()
  if (!session?.token) return { valid: false, reason: 'no_token' }
  try {
    const r = await fetch(`${BACKEND}${apiEndPoints.schoolPortalValidate}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'vc-school-token': session.token },
    })
    const data = await r.json()
    if (r.status === 401) {
      return { valid: false, reason: 'expired', error: data?.error || 'Session expired. Please login again.' }
    }
    if (!r.ok || !data?.success) {
      return { valid: false, reason: 'server_error', error: data?.error || 'Session validation failed.' }
    }
    return {
      valid: true,
      account: data.account,
      loginTime: data.loginTime,
      tokenExpiryTime: data.tokenExpiryTime,
    }
  } catch {
    return { valid: false, reason: 'network', error: 'Could not validate session' }
  }
}